export var CatalogProcessStatus;
(function (CatalogProcessStatus) {
    CatalogProcessStatus[CatalogProcessStatus["UNKNOWN"] = 0] = "UNKNOWN";
    CatalogProcessStatus[CatalogProcessStatus["COMPLETED"] = 1] = "COMPLETED";
    CatalogProcessStatus[CatalogProcessStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    CatalogProcessStatus[CatalogProcessStatus["COMPLETED_WITH_ISSUE"] = 3] = "COMPLETED_WITH_ISSUE";
    CatalogProcessStatus[CatalogProcessStatus["FAILED"] = 4] = "FAILED";
})(CatalogProcessStatus || (CatalogProcessStatus = {}));
